var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 14.0417V21.7854C21.875 21.9952 21.8327 22.2029 21.7507 22.3961C21.6687 22.5892 21.5486 22.7638 21.3976 22.9096C21.2467 23.0553 21.0679 23.1691 20.872 23.2443C20.676 23.3194 20.467 23.3543 20.2573 23.3469L20.1187 23.3354L12.5 22.3833V14.0417H21.875ZM10.4167 14.0417V22.1229L4.95 21.4396C4.44605 21.3766 3.98245 21.1317 3.64638 20.7509C3.3103 20.3702 3.12489 19.8797 3.125 19.3719V14.0417H10.4167ZM20.1187 2.66458C20.327 2.63857 20.5383 2.65476 20.7401 2.71218C20.9419 2.76961 21.1301 2.86709 21.2934 2.99881C21.4567 3.13054 21.5918 3.29381 21.6907 3.47888C21.7895 3.66396 21.8501 3.86705 21.8687 4.07604L21.875 4.21458V11.9583H12.5V3.61666L20.1187 2.66458ZM10.4167 3.87708V11.9583H3.125V6.62812C3.12489 6.12025 3.3103 5.62983 3.64638 5.24905C3.98245 4.86828 4.44605 4.62339 4.95 4.56041L10.4167 3.87708Z",
    fill: "#2167FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWindows);
export default __webpack_public_path__ + "static/media/logo-windows.0a02155604069aa4f6160d4f15c38a3d.svg";
export { ForwardRef as ReactComponent };